// Values match PublicationCollaboration.PUBLICATION_TYPE_CHOICES on the backend
export const PUBLICATION_TYPES = [
  { label: 'Journal Article', value: 'journal_article' },
  { label: 'Book/Monograph', value: 'book' },
  { label: 'Conference Paper', value: 'conference_paper' },
  { label: 'Book Chapter', value: 'book_chapter' },
  { label: 'Technical Report', value: 'technical_report' },
  { label: 'White Paper', value: 'white_paper' },
  { label: 'Preprint', value: 'preprint' },
  { label: 'Thesis/Dissertation', value: 'thesis' },
];

// Publication lifecycle; values are Proposal.STATUS_CHOICES on the backend
export const PUBLICATION_STATUSES = [
  { value: 'drafting', label: 'Drafting', color: 'default' },
  { value: 'internal_review', label: 'Internal Review', color: 'info' },
  { value: 'submitted', label: 'Submitted', color: 'primary' },
  { value: 'under_review', label: 'Under Review', color: 'primary' },
  { value: 'revision', label: 'Revision', color: 'warning' },
  { value: 'accepted', label: 'Accepted', color: 'success' },
  { value: 'published', label: 'Published', color: 'success' },
  { value: 'rejected', label: 'Rejected', color: 'error' },
  { value: 'withdrawn', label: 'Withdrawn', color: 'default' },
];

export const publicationTypeLabel = (value) =>
  PUBLICATION_TYPES.find((t) => t.value === value)?.label || value || '';

export const publicationStatus = (value) =>
  PUBLICATION_STATUSES.find((s) => s.value === value) || { value, label: value, color: 'default' };
